import React from 'react';
import * as Styled from './styled';
import { Props } from './types';

function Tooltip({ children, text, placement, width }: Props) {
  if (!text) return children;

  const childrenWithAriaLabel = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        'aria-label': text,
      } as React.HTMLAttributes<HTMLElement>);
    }
    return child;
  });

  return (
    <Styled.Wrapper>
      <Styled.TooltipText $width={width} $placement={placement}>
        <Styled.Text>{text}</Styled.Text>
      </Styled.TooltipText>
      {childrenWithAriaLabel}
    </Styled.Wrapper>
  );
}

Tooltip.defaultProps = {
  width: '137px',
};

export default Tooltip;
